export default __webpack_public_path__ + "static/media/avatar_trex7.3e1f1036.mp3";